import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressModel } from '../../../../../../shared/models/address.model';
import { PaymentStepsService } from '../../../../../services/payment-steps.service';
import { PaymentService } from '../../../../../services/payment.service';
import { CardModel } from '../../../../../../shared/models/payment/card.model';
import { PaymentMethodModel } from '../../../../../../shared/models/payment-method.model';

@Component({
    'selector': 'payment-payment-option-card-option-list',
    'templateUrl': './payment.payment.option.card.option.list.component.html'
})
export class PaymentPaymentOptionCardOptionListComponent implements OnInit {
    public differentBillingAddressFilled = false;
    public differentBillingAddress = false;
    public selectedCard: CardModel = null;

    @Input() paymentMethod: PaymentMethodModel;
    @Input() index: number;
    @Input() cardIndex: number;
    @Input() cards: Array<CardModel> = [];
    @Input() deliverable: boolean;
    @Input() cardsCount: Array<number>;
    @Output() submitted: EventEmitter<AddressModel> = new EventEmitter();
    @Output() findingZipCode: EventEmitter<string> = new EventEmitter();
    @Output() foundZipCode: EventEmitter<string> = new EventEmitter();
    @Output() notFoundZipCode: EventEmitter<string> = new EventEmitter();
    @Output() filled: EventEmitter<CardModel> = new EventEmitter();
    @Output() unfilled: EventEmitter<any> = new EventEmitter();

    constructor(
        protected paymentStepsService: PaymentStepsService,
        protected paymentService: PaymentService
    ) { }

    ngOnInit() {
        if (!this.deliverable) {
            this.differentBillingAddress = true;
        }

        this.unfilled.emit(null);
    }

    /**
     * filled event listener.
     **/
    public onFilledAddress(address: AddressModel) {
        this.differentBillingAddressFilled = true;
        if (!this.deliverable) {
            this.paymentService.setBillingAddress(address);
        }

        this.checkFulfilment();
    }
    /**
     * unfilled event listener.
     **/
    public onUnfilledAddress() {
        this.differentBillingAddressFilled = false;
        this.checkFulfilment();
    }
    /**
     * submitted event listener.
     **/
    public onSubmitted(address: AddressModel): void {
        this.submitted.emit(address);
        this.paymentService.setBillingAddress(address);
    }
    /**
     * findingZipCode event listener.
     **/
    public onFindingZipCode(zipCode) {
        this.findingZipCode.emit(zipCode);
    }
    /**
     * foundZipCode event listener.
     **/
    public onFoundZipCode(zipCode) {
        this.foundZipCode.emit(zipCode);
    }
    /**
     * notFoundZipCode event listener.
     **/
    public onNotFoundZipCode(zipCode) {
        this.notFoundZipCode.emit(zipCode);
    }
    /**
     * Verify if card form was fulfilled.
     **/
    public checkFulfilment() {
        const billingAddressValid = (!this.differentBillingAddress || this.differentBillingAddressFilled);

        if (billingAddressValid && this.selectedCard !== null) {
            if (this.paymentMethod.allow_multiple_cards && this.cards.length > 1) {
                this.paymentService.pushCard(this.cardIndex, this.selectedCard);
                this.filled.emit();
                return;
            }
            this.paymentService.setCard(this.selectedCard);
            this.filled.emit();
        } else {
            this.unfilled.emit(null);
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/payment/payment/option/card/option/list/payment.payment.option.card.option.list.component.ts